export default __webpack_public_path__ + "static/media/DailyThing_03.85cf6015.png";